import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=8047e3b8"
import script from "./passwordReset.vue?vue&type=script&lang=js"
export * from "./passwordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8047e3b8')) {
      api.createRecord('8047e3b8', component.options)
    } else {
      api.reload('8047e3b8', component.options)
    }
    module.hot.accept("./passwordReset.vue?vue&type=template&id=8047e3b8", function () {
      api.rerender('8047e3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/passwordReset.vue"
export default component.exports